export class Slot {
  constructor(
    private readonly id: number,
    private readonly uuid: string,
    private readonly name: string,
    private readonly failed: number,
    private readonly passed: number,
    private readonly reportId: number | null
  ) {}

  getId() {
    return this.id;
  }

  getUuid() {
    return this.uuid;
  }

  getName() {
    return this.name;
  }

  getFailed() {
    return this.failed;
  }

  getPassed() {
    return this.passed;
  }

  getReportId() {
    return this.reportId;
  }
}
